import { CampaignActionsDropdown } from '../campaign-actions-dropdown';
import { GoogleAdAccountSelectionModal } from '@/components/glitch-ui/google-ad-account-selection-modal';
import { useCampaignGoogleAdsTransfer } from '@/hooks/useCampaignGoogleAdsTransfer';
import { CampaignData, GoogleAdsAccount } from '@/lib/types';

interface CampaignWithTransferProps {
  campaign: CampaignData;
  className?: string;
  variant?: 'table' | 'header';
  onCopy?: () => void;
  onDelete?: () => void;
  onNewAd?: () => void;
  newAdDisabled?: boolean;
  viewInGoogleAdsAction?: {
    onClick: () => void;
    disabled?: boolean;
    disabledReason?: string;
  };
}

export const CampaignWithTransfer = ({
  campaign,
  className,
  variant = 'table',
  onCopy,
  onDelete,
  onNewAd,
  newAdDisabled,
  viewInGoogleAdsAction,
}: CampaignWithTransferProps) => {
  const {
    isTransferModalOpen,
    selectedCampaign,
    openTransferModal,
    closeTransferModal,
    handleTransfer,
  } = useCampaignGoogleAdsTransfer();

  const handleTransferClick = () => {
    // Get the Google Ads account ID from the googleads_account object
    const googleAdsAccountId = campaign.googleads_account?.googleads_account_id;
    
    if (googleAdsAccountId) {
      openTransferModal(
        campaign.id,
        campaign.name || 'Unnamed Campaign',
        parseInt(googleAdsAccountId) // Convert string to number for the hook
      );
    }
  };

  // Custom handler for the modal that will transfer instead of select
  const handleAccountSelectForTransfer = async (account: GoogleAdsAccount) => {
    if (selectedCampaign) {
      handleTransfer(account.googleads_account_id);
    }
  };

  return (
    <>
      <CampaignActionsDropdown
        campaign={campaign}
        className={className}
        variant={variant}
        onCopy={onCopy}
        onDelete={onDelete}
        onNewAd={onNewAd}
        newAdDisabled={newAdDisabled}
        viewInGoogleAdsAction={viewInGoogleAdsAction}
        onTransferCampaign={handleTransferClick}
      />

      <GoogleAdAccountSelectionModal
        isOpen={isTransferModalOpen}
        onClose={closeTransferModal}
        mode="transfer"
        campaignName={selectedCampaign?.name}
        currentGoogleAdsAccountId={selectedCampaign?.currentGoogleAdsAccountId}
        onAccountSelect={handleAccountSelectForTransfer}
      />
    </>
  );
};